/* TOUNI HARMONIE (03/11, local) — petits comportements d'affichage, sans toucher au contenu.
   1) FAQ en accordéon (pages de contenu, ex. magasin) : une seule question ouverte à la fois.
   2) Long texte de référencement de la page magasin (.seo-local) : replié à 3-4 lignes + « Lire la suite » / « Réduire ».
      Le texte reste entièrement dans le HTML ; sans JavaScript il s'affiche en entier. */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    // 1) accordéons exclusifs
    document.querySelectorAll('.mag-faq, .tns .faq, [data-tn-accordion]').forEach(function(w){
      if(w.__tnAcc) return; w.__tnAcc=true;
      w.addEventListener('toggle',function(e){
        var d=e.target; if(d.tagName!=='DETAILS'||!d.open) return;
        w.querySelectorAll('details[open]').forEach(function(o){ if(o!==d) o.open=false; });
      },true);
    });
    // 2) texte SEO de la page magasin replié
    document.querySelectorAll('.tns .seo-local').forEach(function(sec,i){
      if(sec.__tnFold) return; sec.__tnFold=true;
      var box=document.createElement('div'); box.className='tn-fold'; box.id='tn-fold-'+i;
      var kids=[].slice.call(sec.children);
      kids.forEach(function(k){ box.appendChild(k); });
      sec.appendChild(box);
      var b=document.createElement('button'); b.type='button'; b.className='tn-fold__btn';
      b.setAttribute('aria-expanded','false'); b.setAttribute('aria-controls',box.id);
      b.innerHTML='<span>Lire la suite</span><svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      sec.appendChild(b); sec.classList.add('tn-fold-on');
      b.addEventListener('click',function(){
        var open=sec.classList.toggle('is-open');
        b.setAttribute('aria-expanded',open?'true':'false');
        b.querySelector('span').textContent=open?'Réduire':'Lire la suite';
      });
    });
  });
})();
